import { createContext, useContext, useEffect, useState } from "react";

const RouterContext = createContext(null);

const normalizePath = (value) => {
  const path = (value || "/").split(/[?#]/)[0];
  return path === "/" ? "/" : `/${path.replace(/^\/+|\/+$/g, "")}/`;
};

export function RouterProvider({ children }) {
  const [pathname, setPathname] = useState(() => normalizePath(window.location.pathname));
  useEffect(() => {
    const onPopState = () => setPathname(normalizePath(window.location.pathname));
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);
  const navigate = (to, { replace = false } = {}) => {
    const next = normalizePath(to);
    if (next === pathname) return;
    window.history[replace ? "replaceState" : "pushState"]({}, "", next);
    setPathname(next);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return <RouterContext.Provider value={{ pathname, navigate }}>{children}</RouterContext.Provider>;
}

export const useRouter = () => useContext(RouterContext);

export function AppLink({ href, onClick, children, ...props }) {
  const { navigate } = useRouter();
  return <a href={href} onClick={(event) => {
    onClick?.(event);
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    navigate(href);
  }} {...props}>{children}</a>;
}

export const splitRoute = (pathname) => {
  const parts = normalizePath(pathname).split("/").filter(Boolean);
  const locale = parts[0] === "es" ? "ES" : parts[0] === "et" ? "ET" : "EN";
  if (locale !== "EN") parts.shift();
  return { locale, route: `/${parts.join("/")}${parts.length ? "/" : ""}` };
};

export const localizedPath = (locale, route = "/") => {
  const prefix = locale === "ES" ? "/es" : locale === "ET" ? "/et" : "";
  return normalizePath(`${prefix}${route === "/" ? "" : route}`);
};
